"use client"

import { useState, useCallback, useRef } from "react"
import { toast } from "sonner"

export function useCopyToClipboard(timeout = 2000) {
  const [copiedKey, setCopiedKey] = useState<string | null>(null)
  const timerRef = useRef<ReturnType<typeof setTimeout>>(null)

  const copy = useCallback(
    async (text: string, key = "default") => {
      try {
        await navigator.clipboard.writeText(text)
        setCopiedKey(key)
        if (timerRef.current) clearTimeout(timerRef.current)
        timerRef.current = setTimeout(() => setCopiedKey(null), timeout)
        toast.success("Copied to clipboard")
      } catch {
        toast.error("Failed to copy to clipboard")
      }
    },
    [timeout]
  )

  const isCopied = useCallback((key = "default") => copiedKey === key, [copiedKey])

  return { copiedKey, copy, isCopied } as const
}
